import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.laboratories;

export default class Laboratories extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.attr(null),
      name: this.string(''),
      code: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/laboratories',
    },
  };
}
